import { render, staticRenderFns } from "./AddToComparisonBtn.vue?vue&type=template&id=62f4f228&scoped=true&"
import script from "./AddToComparisonBtn.vue?vue&type=script&lang=js&"
export * from "./AddToComparisonBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddToComparisonBtn.vue?vue&type=style&index=0&id=62f4f228&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f4f228",
  null
  
)

export default component.exports